// ----------------------------------------------------------------------

const shape = {
  borderRadius: 5,
  borderRadiusSm: 12,
  borderRadiusMd: 16
};

export default shape;
